import { render, staticRenderFns } from "./wechat-app-bill.vue?vue&type=template&id=3e47bf8a&scoped=true&"
import script from "./wechat-app-bill.vue?vue&type=script&lang=ts&"
export * from "./wechat-app-bill.vue?vue&type=script&lang=ts&"
import style0 from "./wechat-app-bill.vue?vue&type=style&index=0&id=3e47bf8a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e47bf8a",
  null
  
)

export default component.exports